export default __webpack_public_path__ + "03185c0c78d0b241b73f2e18a38edc7d-marker-recommended.svg";